import RadioBox from "Components/FormControl/RadioBox/RadioBox";
import moment from "moment";
import { convertDateTime } from "Helpers/date";
import React, { useContext, useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useNavigate } from "react-router-dom";
import { getAddressTypeList } from "../../../api/addressType";
import { getReplaceRefundIrderDetails } from "../../../api/report";
import { Bar,Line } from "react-chartjs-2";
import { Link } from "react-router-dom";

import SearchIcon from "../../../Assets/images/search.svg";
import Date from "../../../Components/FormControl/Date/Date";
import Select from "../../../Components/FormControl/Select/Select";
import ReactTable from "../../../Components/Table/Table";
// import TableContainer from 'Components/Table/TableContainer';
import CalendarIcon from "../../../Assets/images/calendar.svg";
import CloseIcon from "../../../Assets/images/close.svg";
import ExportIcon from "./../../../Assets/images/Export.svg";

// Context
import { AppContext } from "../../../Context/AppContext";
import { MODULES, REF_REPL_FILTER_MENUS } from "../../../Helpers/Constants";
import { getAccessByModuleName } from "../../../Routes/Routes";

// Components
import Header from "./../../../Components/Header/Header";
import styles from "./index.module.scss";
import CheckBox from "Components/FormControl/CheckBox/CheckBox";
import { setAllStore } from "Helpers/setAllStore";
import ParetoChart from "./ParetoChart";
import GlobalDateFilters from "Components/GlobalDateFilters/GlobalDateFilters";
import { Tooltip as ReactTooltip } from "react-tooltip";
import TableContainer from "Components/Table/TableContainer";

const ReplaceRefundOrders = () => {
  const { showToastMessage } = useContext(AppContext);
  const navigate = useNavigate();
  const [type, setType] = useState("delivery_date");
  const [buildingList, setBuildingList] = React.useState([]);


  const [fromDate, setFromDate] = useState(
    moment().startOf("isoWeek").format("ddd MMM DD, YYYY")
  );
  const [toDate, setToDate] = useState(
    moment().endOf("isoWeek").format("ddd MMM DD, YYYY")
  );
  // const [data, setData] = React.useState([]);
  const [pageCount, setPageCount] = React.useState(1);
  const reference = React.useRef(null);
  const [exportData, setExportData] = React.useState([]);
  const [exportHeader, setExportHeader] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  // Pareto Chart selected bar filter state
  const [selectedBar, setSelectedBar] = React.useState(null);

  // Selected Column State
  //Set default selected columns
  const [selectedColumns, setSelectedColumns] = useState({
    "order_number": true,
    "action_type": true,
    "total": true,
    "refund": true,
    "reason_team": true,
    "reason_type_name": true,
    "reason_subtype_name": false,
    "responsible_person": false,
    "order_date": false,
    "delivery_date": false,
    "action_on_date": false,
    "message": false,
    "product_name": true
  });

  const [firstTimePageLoad, setFirstTimePageLoad] = React.useState(false);
  const [selectedPeriod, setSelectedPeriod] = React.useState("weekly");
  const [selectedPeriodLabel, setSelectedPeriodLabel] =
    React.useState("By Week");
  
  const [tabFilters, setTabFilters] = useState({
    record_type: "all",
    responsible_team_type: "all",
    reason_type: "all",
  });

  const [defaultFilter, setDefaultFilter] = useState({
    pageIndex: 0,
    pageSize: 10,
    sortBy: [],
    filters: [],
    globalFilter: "",
  });

  const [defaultFilters, setDefaultFilters] = useState([]);

  useEffect(() => {
    if (selectedBar) {
      setDefaultFilters([
        ...defaultFilters,
        { id: "reason_subtype_name", value: selectedBar?.label },
      ]);
    }
  }, [selectedBar]);

  //Define initial state for refundReplacementData
  const refundReplacementDataInitial = {
    total_orders: 0,
    total_affected_orders: 0,
    complaint_rate: 0,
    full_refund_order: 0,
    partial_refund_order: 0,
    replaced_order: 0,
    final_data: [],
    graphDataArr: {
      graphDataWithFilters: {
        graphAllKey: [],
        graphAllValue: [],
      },
    },
  }

  const [checkAllStore, setCheckAllStore] = useState(true);
  const [chartData, setChartData] = React.useState(null);
  const [graphAllData, setGraphAllData] = React.useState([]);
  // Define initial state for refundReplacementData
  const [refundReplacementData, setRefundReplacementData] = React.useState(refundReplacementDataInitial);

  const getAddressType = async () => {
    let response = await getAddressTypeList();
    if (response && response.status === 200) {
      let addressTypeArr = [];
      response.data.data.rows?.forEach((d, i) => {
        let tempArr = {
          id: d.name,
          title: d.name,
        };
        addressTypeArr.push(tempArr);
      });
      setBuildingList(addressTypeArr);
    } else {
      showToastMessage(undefined, response.data.message, "error", false);
    }
  };

  useEffect(() => {
    getAddressType();
  }, []);

  const fetchData = async ({
    pageIndex,
    pageSize,
    sortBy,
    globalFilter,
    filters,
    fromDateDefault,
    toDateDefault,
  }) => {

    /*
      # when all store checkbox is checked at that time we set page_wise_all_store_checkbox=0 in local storage & this logic write in setAllStore function
      
    */
    // setChartData(null);
    setAllStore(checkAllStore);

    setDefaultFilter({ pageSize, pageIndex, filters, globalFilter, sortBy });

    setLoading(true);
    const postData = {
      date_type: type,
      record_type: tabFilters.record_type,
      responsible_team_type: tabFilters.responsible_team_type,
      reason_type: tabFilters.reason_type,
      start_date: fromDateDefault ?? moment(fromDate).format("YYYY-MM-DD"),
      end_date: toDateDefault ?? moment(toDate).format("YYYY-MM-DD"),
      sortBy,
    };

    if (!firstTimePageLoad) {
      const response = await getReplaceRefundIrderDetails(postData);
      if (response && response.status === 200) {
        // setData(response.data.data.final_data);
        //Update the refundReplacementData state with the response data
        setRefundReplacementData(response.data.data)
        setPageCount(Math.ceil(response.data.data.final_data.length / pageSize));
        if(pageIndex === 0){
          setGraphAllData(response?.data?.data?.graphDataArr);
          // handleGraphDataChange(response?.data?.data?.graphDataArr)
        }
        
      } else if (response.status === 403) {
        showToastMessage(undefined, response.data.message, "error", false);
        navigate("/profile");
      } else {
        showToastMessage(undefined, response.data.message, "error", false);
      }
    } else {
      setFirstTimePageLoad(false);
    }
    setLoading(false);

    //when the all store checkbox is checked and we get all store data(after the API call) then we set the selected store id=dropdown selected store in local storage and this logic writes in setAllStore  function
    if (checkAllStore) { setAllStore(false) }
  };

  const selectedColumn = async (column) => {
    setSelectedColumns(column);
  };

  // const handleSelectedPeriod = async (id) => {
  //   if (id === "weekly") {
  //     setFromDate(moment().startOf("isoWeek").format("ddd MMM DD, YYYY"));
  //     setToDate(moment().endOf("isoWeek").format("ddd MMM DD, YYYY"));
  //     setSelectedPeriodLabel("By Week");
  //   } else if (id === "monthly") {
  //     setFromDate(moment().startOf("month").format("ddd MMM DD, YYYY"));
  //     setToDate(moment().endOf("month").format("ddd MMM DD, YYYY"));
  //     setSelectedPeriodLabel("By Month");
  //   } else if (id === "yearly") {
  //     setFromDate(moment().startOf("year").format("ddd MMM DD, YYYY"));
  //     setToDate(moment().endOf("year").format("ddd MMM DD, YYYY"));
  //     setSelectedPeriodLabel("By Year");
  //   }
  // };

  // const handleFromDate = async (data) => {
  //   if (selectedPeriod === "weekly") {
  //     setToDate(moment(data).add(7, "days").utc().format("ddd MMM DD, YYYY"));
  //   } else if (selectedPeriod === "monthly") {
  //     setToDate(moment(data).add(1, "months").utc().format("ddd MMM DD, YYYY"));
  //   } else if (selectedPeriod === "yearly") {
  //     setToDate(moment(data).add(1, "years").utc().format("ddd MMM DD, YYYY"));
  //   }
  // };

  // const handleToDate = async (data) => {
  //   if (selectedPeriod === "weekly") {
  //     setFromDate(
  //       moment(data).subtract(7, "days").utc().format("ddd MMM DD, YYYY")
  //     );
  //   } else if (selectedPeriod === "monthly") {
  //     setFromDate(
  //       moment(data).subtract(1, "months").utc().format("ddd MMM DD, YYYY")
  //     );
  //   } else if (selectedPeriod === "yearly") {
  //     setFromDate(
  //       moment(data).subtract(1, "years").utc().format("ddd MMM DD, YYYY")
  //     );
  //   }
  // };

  const handleExportReplaceRefundOrders = async () => {

    /*
      # when all store checkbox is checked at that time we set page_wise_all_store_checkbox=0 in local storage & this logic write in setAllStore function
      
    */
    setAllStore(checkAllStore);

    let postData = {
      isExport: true,
      date_type: type,
      record_type: tabFilters.record_type,
      responsible_team_type: tabFilters.responsible_team_type,
      reason_type: tabFilters.reason_type,
      start_date: moment(fromDate).format("YYYY-MM-DD"),
      end_date: moment(toDate).format("YYYY-MM-DD"),
    };

    const response = await getReplaceRefundIrderDetails(postData);

    if (response && response.status === 200) {
      setExportHeader(response.data.data.header);
      const transformedData = response.data.data.data.final_data.map(row => ({
        ...row,
        order_number: `=HYPERLINK("https://admin.frenchflorist.com/admin/orders/view/${row.id}","${row.order_number}")`.replaceAll('"', '""'),
      }));
      setExportData(transformedData);
      
      // Use setTimeout to ensure state is updated before triggering download
      setTimeout(() => {
        reference.current?.link?.click();
      }, 100);
    } else if (response.status === 403) {
      showToastMessage(undefined, response.data.message, "error", false);
      navigate("/profile");
    } else {
      showToastMessage(undefined, response.data.message, "error", false);
    }

    //when the all store checkbox is checked and we get all store data(after the API call) then we set the selected store id=dropdown selected store in local storage and this logic writes in setAllStore  function
    if (checkAllStore) { setAllStore(false) }
  };

  const handleClearSearch = async (event) => {
    event.preventDefault();
    // setChartData(null);
    setFromDate(moment().startOf("isoWeek").format("ddd MMM DD, YYYY"));
    setToDate(moment().endOf("isoWeek").format("ddd MMM DD, YYYY"));
    setSelectedPeriod("weekly");
    fetchData({
      ...defaultFilter,
      fromDateDefault: moment().startOf("isoWeek").format("YYYY-MM-DD"),
      toDateDefault: moment().endOf("isoWeek").format("YYYY-MM-DD"),
    });
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Order No",
        accessor: "order_number",
        isVisible: selectedColumns["order_number"] || true,
        disableFilters: false,
        Cell: ({ value, row, column }) => {
          return (
            <Link to={`/admin/orders/view/${row.original.id}`}>
              <span className={`cursor-pointer`}>
                {`${row.original.order_number}`}
              </span>
            </Link>
          );
        },
      },
      {
        Header: "Action Type",
        accessor: "action_type",
        isVisible: selectedColumns["action_type"] || true,
        disableFilters: false,
        colWidth: 160,
      },
      {
        Header: "Original Order Value",
        accessor: "total",
        isVisible: selectedColumns["total"] || true,
        placeholder: "Price",
        disableFilters: false,
        Cell: ({ value, row, column }) => {
          return `$${row.original.total}`;
        },
      },
      {
        Header: "Total Amount Refunded",
        accessor: "refund",
        isVisible: selectedColumns["refund"] || true,
        placeholder: "Price",
        disableFilters: false,
        Cell: ({ value, row, column }) => {
          return `$${row.original.refund}`;
        },
      },
      {
        Header: "Team",
        accessor: "reason_team",
        isVisible: selectedColumns["reason_team"] || true,
        disableFilters: false,
      },
      {
        Header: "Reason Type",
        accessor: "reason_type_name",
        isVisible: selectedColumns["reason_type_name"] || true,
        disableFilters: false,
      },
      {
        Header: "Reason Sub Type",
        accessor: "reason_subtype_name",
        isVisible: selectedColumns["reason_subtype_name"] || true,
        disableFilters: false,
      },
      {
        Header: "Person Responsible",
        accessor: "responsible_person",
        isVisible: selectedColumns["responsible_person"] || false,
        disableFilters: false,
        Cell: ({ value, row, column }) => {
          return (
            <div>
              {row.original.responsible_person
                ? row.original.responsible_person
                : "-"}
            </div>
          );
        },
      },
      {
        Header: "Order Placed Date",
        accessor: "order_date",
        isVisible: selectedColumns["order_date"] || false,
        disableFilters: true,
        disableSortBy: true,
        colWidth: 130,
        Cell: ({ value, row, column }) => {
          return (
            <div>
              {row.original?.order_date
                ? convertDateTime(row.original.order_date, "iso", "ccc LLL dd, yyyy, hh:mm a")
                : "-"}
            </div>
          );
        },
      },
      {
        Header: "Delivery Date",
        accessor: "delivery_date",
        isVisible: selectedColumns["delivery_date"] || false,
        disableFilters: true,
        disableSortBy: true,
        colWidth: 130,
        Cell: ({ value, row, column }) => {
          return (
            <div>
              {row.original.delivery_date &&
              row.original.delivery_date !== null
              ? row.original.delivery_time_type === "Anytime"
                ? convertDateTime(row.original.delivery_date, 'iso', "ccc LLL dd, yyyy") +
                  " " +
                  row.original.delivery_time_type
                : convertDateTime(row.original.delivery_date, 'iso', "ccc LLL dd, yyyy, hh:mm a")
              : "-  "}
            </div>
          );
        },
      },
      {
        Header: "Action On",
        accessor: "action_on_date",
        isVisible: selectedColumns["action_on_date"] || false,
        disableFilters: true,
        disableSortBy: true,
        colWidth: 130,
        Cell: ({ value, row, column }) => {
          return (
            <div>
              {row.original?.action_on_date
                ? convertDateTime(row.original.action_on_date, "iso", "ccc LLL dd, yyyy, hh:mm a")
                : "-"}
            </div>
          );
        },
      },
      {
        Header: "Comments",
        accessor: "message",
        isVisible: selectedColumns["message"] || false,
        disableFilters: false,
        disableSortBy: true,
        colWidth: 220,
        Cell: ({ value, row, column }) => {
          return (
            <div>
              {
                row.original.message && row.original.message !== null
                  ? row.original.message
                : "-"
              }</div>
          );
        },
      },
      {
        Header: "Products Ordered",
        accessor: "product_name",
        isVisible: selectedColumns["product_name"] || false,
        disableFilters: true,
        disableSortBy: true,
        // colWidth: 250,
        Cell: ({ value, row, column }) => {
          return row.original?.product_name?.length < 75 ? (
            `${row.original?.product_name ?? ""}`
          ) : (
            <div data-tooltip-id={`product_name_${row.id}`}>
              {row.original?.product_name.slice(0, 75) + "...."}
              <ReactTooltip
                id={`product_name_${row.id}`}
                place="top"
                arrowColor="#000"
                className="extraClass"
                positionStrategy="fixed"
                delayHide={100}
                delayShow={500}
              >
                <p className="py-1 text-center">{row.original?.product_name}</p>
              </ReactTooltip>
            </div>
          );
        },
      },
    ],
    [buildingList]
  );

  const handleTabChange = (value, filterType) => {
    // Update the specific filter in the filters state
    setTabFilters(prevFilters => ({
      ...prevFilters,
      [filterType]: value
    }));
  };

  // const handleGraphDataChange = (data) => {
  //   let chartDataSet = {
  //     labels: data?.graphDataWithFilters?.graphAllKey,
  //     datasets: [
  //       {
  //         label: "Reasons",
  //         data: data?.graphDataWithFilters?.graphAllValue,
  //         backgroundColor: "#CB998D",
  //       },
  //     ],
  //   };

  //  setChartData(chartDataSet);
  // }

  useEffect(() => {
    if(tabFilters && graphAllData){
      // handleGraphDataChange(graphAllData);
      fetchData({
        ...defaultFilter,
        pageIndex: 0,
      });
    }
  }, [tabFilters]);

  const filterMenus = REF_REPL_FILTER_MENUS;
  const selectedPeriodOptions = [
    { id: "weekly", title: "Weekly", label: "By Week" },
    { id: "monthly", title: "Monthly", label: "By Month" },
    { id: "yearly", title: "Yearly", label: "By Year" },
    { id: "custom", title: "Custom", label: "Custom" },
  ];

  return (
    <>
      <Header title={`Replacements and Refunds (${refundReplacementData.total_orders || 0})`} />
      <div id="MainContent" className="main-content">
        <div style={{ float: "left", width: "100%" }}>
          <div className={"row d-flex align-items-end"}>
            {/* <div className="col-12 d-flex align-items-center">
              <span
                className="mb-0 mt-2 pb-0 d-inline-bock mr-3"
                style={{ lineHeight: 1 }}
              >
                Filter By
              </span>
              <RadioBox
                selectedValue={type}
                onChange={() => {
                  if (setType) {
                    setType("order_date");
                  }
                }}
                label="Order date"
                value="order_date"
              />
              <RadioBox
                selectedValue={type}
                onChange={() => {
                  if (setType) {
                    setType("delivery_date");
                  }
                }}
                label="Delivery date"
                value="delivery_date"
              />
            </div>
            <div className="col-sm-2 col-xs-12">
              <Select
                label={selectedPeriodLabel}
                value={selectedPeriod}
                onChange={(data) => {
                  setSelectedPeriod(data);
                  handleSelectedPeriod(data);
                }}
                options={[
                  { id: "weekly", title: "Weekly" },
                  { id: "monthly", title: "Monthly" },
                  { id: "yearly", title: "Yearly" },
                  { id: "custom", title: "Custom" },
                ]}
                disabled={false}
              />
            </div>
            <div className="col-sm-3 col-xs-12">
              <Date
                label="Filter From"
                value={fromDate}
                dateFormat="ddd MMM DD, YYYY"
                type="date"
                fieldIcon={CalendarIcon}
                onChange={(fromDate) => {
                  setFromDate(moment(fromDate).format("ddd MMM DD, YYYY"));
                  handleFromDate(fromDate);
                }}
              />
            </div>
            <div className="col-sm-3 col-xs-12">
              <Date
                label="Filter To "
                value={toDate}
                dateFormat="ddd MMM DD, YYYY"
                type="date"
                fieldIcon={CalendarIcon}
                onChange={(toDate) => {
                  setToDate(moment(toDate).format("ddd MMM DD, YYYY"));
                  handleToDate(toDate);
                }}
              />
            </div>
            <div className="col-sm-2 col-xs-12">
              <CheckBox
                value={checkAllStore}
                label="All Stores"
                onChange={(data) => { setCheckAllStore(data) }}
              />
            </div>
             <div className="col-sm-2 col-xs-12">
               <div className="td-actions pt-4">
                <span
                  onClick={(e) => fetchData(defaultFilter)}
                  className={`link cursor-pointer ${styles.searchIconWrapper}`}
                >
                  <img className={styles.searchIcon} src={SearchIcon} alt="" />
                </span>
                <span
                  onClick={(e) => handleClearSearch(e)}
                  className={`link cursor-pointer ml-3 ${styles.clearIconWrapper}`}
                >
                  <img className={styles.clearIcon} src={CloseIcon} alt="" />
                </span>
                {exportData && exportData.length > 0 && (
                  <CSVLink
                    ref={reference}
                    style={{
                      display: "none",
                      float: "right",
                      marginTop: "25px",
                    }}
                    data={exportData}
                    headers={exportHeader}
                    filename={`replacements_and_refunds_report${convertDateTime("", "local")}.csv`}
                    className={`link cursor-pointer ml-3 ${styles.searchIconWrapper}`}
                  >
                    DownLoad
                  </CSVLink>
                )}
                {/* {accessExport && accessExport.permissions.write_access && ( */}
                {/* <span
                  onClick={(e) => handleExportReplaceRefundOrders()}
                  className={`link cursor-pointer ${styles.searchIconWrapper}`}
                  style={{ float: "right" }}
                >
                  <img
                    className={styles.searchIcon}
                    src={ExportIcon}
                    alt=""
                  />
                </span> 
                {/* )} 
              </div> 
            </div> */}
            <div className="col-sm-11 col-xs-12 m-0 p-0">
              <GlobalDateFilters
                isDateFilter
                isSearchIcon
                isClearSearchBtn
                isAllCheckStoreBnt
                isFilterByOption
                isFilterByPeriod
                isSelectedPeriodLabel
                selectedPeriodLabel={selectedPeriodLabel}
                setSelectedPeriodLabel={setSelectedPeriodLabel}
                fromDate={fromDate}
                toDate={toDate}
                setFromDate={setFromDate}
                setToDate={setToDate}
                type={type}
                setType={setType}
                fetchData={()=>fetchData({
                  ...defaultFilter
                })}
                handleClearSearch={handleClearSearch}
                checkAllStore={(data)=>{setCheckAllStore(data)}}
                defaultSetCheckAllStore={checkAllStore}
                selectedPeriod={selectedPeriod}
                setSelectedPeriod={setSelectedPeriod}
                periodOptions={selectedPeriodOptions}
                key={"replace-refund-orders"}
              />
            </div>
            <div className="col-sm-1 mb-4">
              {exportData && exportData.length > 0 && (
                <CSVLink
                  ref={reference}
                  style={{
                    display: "none",
                    float: "right",
                    marginTop: "25px",
                  }}
                  data={exportData}
                  headers={exportHeader}
                  filename={`replacements_and_refunds_report${convertDateTime("", "local")}.csv`}
                  className={`link cursor-pointer ml-3 ${styles.searchIconWrapper}`}
                >
                  DownLoad
                </CSVLink>
              )}
              <span
                onClick={(e) => handleExportReplaceRefundOrders()}
                className={`link cursor-pointer mb-2 ${styles.searchIconWrapper}`}
                // style={{ float: "right" }}
              >
                <img
                  className={styles.searchIcon}
                  src={ExportIcon}
                  alt=""
                />
              </span> 
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginLeft: "0px",
              gap: "12px",
            }}
          >
            {filterMenus.map((menu) => {
              return (
                <div className={styles.filterMenu} key={menu.title}>
                  <h3
                    style={{
                      color: "#7A7A7A",
                      width: "120px",
                      margin: "0px",
                      lineHeight: "1.5",
                      marginTop: "10px",
                    }}
                  >
                    {menu.title} :
                  </h3>
                  <div style={{ width: "calc(100% - 0px)" }}>
                    {menu.filter_sub_menus.map((subMenu) => {
                      return (
                        <button
                          key={subMenu.value}
                          onClick={() => handleTabChange(subMenu.value, menu.filter_type)}
                          className={
                            tabFilters[menu.filter_type] === subMenu.value
                              ? styles.tabButtonCustomActive
                              : styles.tabButtonCustom
                          }
                          value={tabFilters[menu.filter_type]}
                        >
                          {subMenu.title}
                        </button>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
          <div className="d-flex align-items-baseline">
            <h3 style={{ color: "#7A7A7A" }}># Full Refunds : {refundReplacementData.full_refund_order}</h3>
            <h3 style={{ color: "#7A7A7A", marginLeft: "20px" }}># Partial Refunds : {refundReplacementData.partial_refund_order}</h3>
            <h3 style={{ color: "#7A7A7A", marginLeft: "20px" }}># Replacements : {refundReplacementData.replaced_order}</h3>
            {/* <h4 style={{ color: "#7A7A7A", marginLeft: "50px" }}>Total Orders : {refundReplacementData.total_orders}</h4> */}
            <h4 style={{ color: "#7A7A7A", marginLeft: "20px" }}>Affected Orders : {refundReplacementData.total_affected_orders}</h4>
            <h4 style={{ color: "#7A7A7A", marginLeft: "20px" }}>Complaint Rate : {`${refundReplacementData.complaint_rate}%`}</h4>
          </div>
          {/* <div style={{ display: "flex",marginLeft: "20px" }}>
            <h3 style={{ color: "#7A7A7A",width:"95px" , margin:"0px" , lineHeight:"1.5" }}>View : </h3>
            <div style={{ width:"calc(100% - 50px)" }}>
              <button
                onClick={() => handleTabChange("all")}
                className={
                  recordType === "all"
                    ? styles.tabButtonCustomActive
                    : styles.tabButtonCustom
                }
                value={recordType}
              >
                All
              </button>
              <button
                onClick={() => handleTabChange("full-refund")}
                className={
                  recordType === "full-refund"
                    ? styles.tabButtonCustomActive
                    : styles.tabButtonCustom
                }
                value={recordType}
              >
                Full Refunds
              </button>
              <button
                onClick={() => handleTabChange("partial-refund")}
                className={
                  recordType === "partial-refund"
                    ? styles.tabButtonCustomActive
                    : styles.tabButtonCustom
                }
                value={recordType}
              >
                Partial Refunds
              </button>
              <button
                onClick={() => handleTabChange("replacement")}
                className={
                  recordType === "replacement"
                    ? styles.tabButtonCustomActive
                    : styles.tabButtonCustom
                }
                value={recordType}
              >
                Replacements
              </button>
            </div>
          </div> */}
          {/* <br /> */}
          {/* <br /> */}
          {/* {chartData &&
            chartData.datasets.length !== 0 && (
              <Bar
                data={chartData}
                style={{ backgroundColor: "#FAFAFB", padding: "20px" }}
                className={styles.graphChart}
              />
            )} */}
          <br></br>
          <br></br>
          <ParetoChart 
            totalOrders={refundReplacementData.total_orders} 
            graphAllLabels={graphAllData?.graphDataWithFilters?.graphAllKey || []} 
            graphAllValues={graphAllData?.graphDataWithFilters?.graphAllValue || []} 
            setSelectedBar={setSelectedBar}
          />
          {/* <ReactTable
            columns={columns}
            data={data}
            fetchData={fetchData}
            loading={loading}
            pageCount={pageCount}
            noDataText={"There is no data to display"}
            defaultFilter={defaultFilter}
            displayGlobalSearch={false}
            manualPagination={false}
          /> */}
          <div id="ReplaceRefundOrders">
            <TableContainer
              columns={columns}
              data={refundReplacementData.final_data}
              noDataText={'There is no data to display'}
              loading={loading}
              disableLastColumnFilter={true}
              defaultFilters={defaultFilters}
              selectedColumn={selectedColumn}
              displayColumnVisibility={true}
              key={"replace-refund-orders-table"}
              isShowSettings={true}
            />
            {/* <ReactTable
              columns={columns}
              data={refundReplacementData.final_data}
              fetchData={fetchData}
              loading={loading}
              pageCount={pageCount}
              noDataText={"There is no data to display"}
              defaultFilter={defaultFilter}
              displayGlobalSearch={false}
              displayColumnVisibility={true}
              selectedColumn={selectedColumn}
            /> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default ReplaceRefundOrders;
